import "./DaShell.css";
import PropTypes from "prop-types";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { useAppTheme } from "../../theme/useTheme";
import { useConfig } from "../../contexts/ConfigContext";
import { useT } from "../../hooks/useT";

const DaShell = ({ children }) => {
  const theme = useAppTheme();
  const { config } = useConfig();

  const { t } = useT();

  const privacyLink =
    config?.environment === "development" ? t(T_KEYS.DA.SHELL.PRIVACYLINK) : t(T_KEYS.DA.SHELL.PRIVACYProdLINK);
  const termsLink =
    config?.environment === "development" ? t(T_KEYS.DA.SHELL.TERMSLINK) : t(T_KEYS.DA.SHELL.TERMSProdLINK);

  return (
    <div className="da-shell-wrapper">
      <div className="da-header"> {theme?.assets?.logo && <img src={theme.assets.logo} alt="Worldline logo" />} </div>

      <div className="da-shell-bg">{children}</div>

      <footer className="da-footer">
        <span className="da-footer-text">
          <Translate tKey={T_KEYS.DA.SHELL.COPYRIGHT} />
        </span>
        <a href={privacyLink} className="da-footer-text" target="_blank" rel="noopener noreferrer">
          <Translate tKey={T_KEYS.DA.SHELL.PRIVACY} />
        </a>
        <a href={termsLink} className="da-footer-text" target="_blank" rel="noopener noreferrer">
          <Translate tKey={T_KEYS.DA.SHELL.TERMS} />
        </a>
      </footer>
    </div>
  );
};

DaShell.propTypes = {
  children: PropTypes.node,
};

export { DaShell };
